export default __webpack_public_path__ + "static/media/wifi-tethering.b1f06af6.svg";